module.exports = __webpack_public_path__ + "static/media/3.31b98784.svg";